/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleCategoryWithIdDto } from '../../models/article-category-with-id-dto';

export interface ShopUpdateArticleCategory$Params {
  'x-trace-id'?: string;
  id: string;
      body: ArticleCategoryWithIdDto
}

export function shopUpdateArticleCategory(http: HttpClient, rootUrl: string, params: ShopUpdateArticleCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleCategoryWithIdDto>> {
  const rb = new RequestBuilder(rootUrl, shopUpdateArticleCategory.PATH, 'put');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ArticleCategoryWithIdDto>;
    })
  );
}

shopUpdateArticleCategory.PATH = '/api/shop/category/{id}';
